import { logGlassbox, buildGlassboxPayload } from '../glassbox.client.logger';
function _log(schemaId, eventType, eventName, params) {
  return logGlassbox(buildGlassboxPayload('Analytics', schemaId, 'Amp', eventType, eventName, 'Web', params));
}
export function logCopyLink(params) {
  return _log(32284, 'CopyLink', 'CopyLinkWebAmp', params);
}
export function logDisplayedDocumentOutput(params) {
  return _log(32290, 'DisplayedDocumentOutput', 'DisplayedDocumentOutputWebAmp', params);
}
export function logDisplayedOutline(params) {
  return _log(32296, 'DisplayedOutline', 'DisplayedOutlineWebAmp', params);
}
export function logGenerateDocumentOutput(params) {
  return _log(32258, 'GenerateDocumentOutput', 'GenerateDocumentOutputWebAmp', params);
}
export function logGeneratedDocument(params) {
  return _log(32270, 'GeneratedDocument', 'GeneratedDocumentWebAmp', params);
}
export function logGeneratedOutline(params) {
  return _log(32298, 'GeneratedOutline', 'GeneratedOutlineWebAmp', params);
}
export function logLoadedAmpDashboard() {
  return _log(32282, 'LoadedAmpDashboard', 'LoadedAmpDashboardWebAmp');
}
export function logLoadedDocumentMode(params) {
  return _log(32264, 'LoadedDocumentMode', 'LoadedDocumentModeWebAmp', params);
}
export function logLoggedChat(params) {
  return _log(32276, 'LoggedChat', 'LoggedChatWebAmp', params);
}
export function logOpenDocumentFromChat(params) {
  return _log(32268, 'OpenDocumentFromChat', 'OpenDocumentFromChatWebAmp', params);
}
export function logOpenDocumentFromDashboard(params) {
  return _log(32288, 'OpenDocumentFromDashboard', 'OpenDocumentFromDashboardWebAmp', params);
}
export function logOpenPresentView(params) {
  return _log(32286, 'OpenPresentView', 'OpenPresentViewWebAmp', params);
}
export function logStartChat() {
  return _log(32274, 'StartChat', 'StartChatWebAmp');
}
export function logStartDownload(params) {
  return _log(32254, 'StartDownload', 'StartDownloadWebAmp', params);
}